<template>
	<core-modal name="no-access" class="om-no-access" :width="710">
		<modals-header name="no-access" />

		<modals-content v-if="validType">
			<img :src="iconSrc" />

			<h2>Unlock This Template with OptinMonster {{ proUpsellPlan }}!</h2>
			<p v-if="upgradeGrowth">
				Get access to high-growth conversion features like Gamified Coupon Wheel Campaigns, Unlimited
				Sub-Accounts, Location Specific Offers and more with OptinMonster {{ proUpsellPlan }}!
			</p>
			<p v-else>
				Get access to high-growth conversion features like Exit Intent® Technology, Campaign Scheduling,
				Countdown Timers and more with OptinMonster {{ proUpsellPlan }}!
			</p>

			<div class="no-access__buttons">
				<core-upgrade-button size="large" color="green" :features="features" utm-medium="TemplateNoAccess">
					Upgrade to {{ proUpsellPlan }}
				</core-upgrade-button>
				<br />
				<core-upgrade-button :features="features" :link-style="true" utm-medium="TemplateNoAccess">
					Learn more about all {{ proUpsellPlan }} features
				</core-upgrade-button>
			</div>
		</modals-content>
	</core-modal>
</template>
<script lang="js">
import { capitalize } from 'optinmonster-js-library/src/utils/strings'
import { mapState, mapGetters } from 'vuex'

export default {
	computed : {
		...mapState('templates', [ 'activeType', 'types' ]),
		...mapGetters('templates', [ 'validType' ]),
		...mapGetters([ 'proUpsellPlan', 'upgradeGrowth' ]),
		features () {
			return [ this.$get(`types.${this.activeType}.feature`, 'none') ]
		},
		typeTitle () {
			return this.$get(`types.${this.activeType}.name`, capitalize(this.activeType))
		},
		iconSrc () {
			const svgs = require.context('../../../assets/images/icons/', false, /\.svg$/)
			return svgs(`./${this.activeType}-icon.svg`)
		},
	},
};
</script>
<style lang="scss">
.om-no-access {
	img {
		width: 200px;
	}
	.header {
		background-color: transparent !important;
		padding: 30px 30px 0 !important;

		.close {
			button {
				background: transparent;
				border: 0;
				color: #b2b4b8;
				padding: 0 !important;
			}
		}
	}

	.content {
		align-items: center;
		color: #646970;
		display: flex;
		flex-direction: column;
		padding: 0 80px 55px !important;
		text-align: center;

		h2 {
			font-size: 1.5em;
			font-weight: 700;
			margin: 5px 0 13px;
			letter-spacing: 0.2px;
		}

		p {
			margin-bottom: 25px;
		}

		.no-access__buttons {
			.omapi-button__primary {
				margin-bottom: 20px;
				font-size: 16px;
				padding: 14px 20px;
			}
		}
	}
}
</style>
